import * as go from 'gojs';
import theme from 'theme/theme';
import { CompletePrintHead } from './PrintHead';
import ContextMenu from '../../../../gojs/contextMenu/contextMenu';
import { store } from 'createStore';
import { setShowContextMenu } from 'store/contextmenu/reducer';

const $ = go.GraphObject.make;

const width = 520;
const height = 842;

const showContextMenu = () => {
  store.dispatch(setShowContextMenu(true));
};

const hideContextMenu = () => {
  store.dispatch(setShowContextMenu(false));
};

const PrintWindowPanel = $(
  go.Node,
  {
    layerName: 'Background',
    resizable: true,
    resizeObjectName: 'SHAPE',
    // specify what resize handles there are and how they look
    resizeAdornmentTemplate: $(
      go.Adornment,
      'Spot',
      $(go.Placeholder), // takes size and position of adorned object
      $(
        go.Shape,
        'Rectangle', // bottom right resize handle
        {
          alignment: go.Spot.BottomRight,
          cursor: 'col-resize',
          desiredSize: new go.Size(16, 16),
          fill: 'lightblue',
          stroke: 'dodgerblue',
        },
      ),
    ),
    selectionAdorned: false, // don't show selection Adornment, a rectangle
  },
  'Auto',
  {
    locationSpot: go.Spot.TopLeft,
    locationObjectName: 'SHAPE',
    selectionObjectName: 'SHAPE',
  },
  new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(
    go.Point.stringify,
  ),
  new go.Binding('zOrder'),
  new go.Binding('visible', 'showPrintWindow'),
  $(
    go.Panel,
    'Viewbox',
    new go.Binding('contextMenu', '', (node, data) => {
      return ContextMenu(data.diagram, showContextMenu, hideContextMenu);
    }),
    $(
      go.Panel,
      'Auto',
      {
        name: 'BODY',
        stretch: go.GraphObject.Fill,
      },
      $(
        go.Shape,
        'Rectangle',
        {
          strokeWidth: 1,
          stroke: 'black',
          name: 'SHAPE',
          stretch: go.GraphObject.Uniform,
          fill: null, //To be able to drag window and select nodes, null is used instead of 'white' (which was requested)
        },
        new go.Binding('width').makeTwoWay(),
        new go.Binding('height').makeTwoWay(),
      ),
      $(
        go.Panel,
        'Viewbox',
        new go.Binding('scale', 'desiredSize', function (s) {
          return s.width / width;
        }).ofObject('SHAPE'),
        { maxSize: new go.Size(200, 200), angle: -45 },
        $(
          go.TextBlock,
          {
            text: '[DRAFT]',
            stroke: theme.palette.grey['300'],
            font: 'normal normal 500 50px Sandvik Sans Text',
          },
          new go.Binding('visible', 'displayDraft'),
        ),
      ),

      CompletePrintHead(width, height),
    ),
  ),
);

export default PrintWindowPanel;
